export enum LookupModelPopulatedButton {
  MAGNIFYING_GLASS = "magnifyingGlass",
  X = "x"
}